/*
 * File: layout.tsx
 * Project: a-a
 * File Created: Tuesday, 22nd October 2024 1:19:21 am
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 24th October 2025 9:22:35 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React, { useEffect, useState } from 'react';
import Sidebar from '../components/shared/Sidebar/Sidebar';
import Header from '../components/shared/Header/Header';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { Box, Button, Typography } from '@mui/material';
import AsanaLogin from '../components/featured/Asana/AsanaLogin/AsanaLogin';
import { AsanaService } from '../service/asana.service';
import ZoomInfoLogin from '../components/featured/ZoomInfo/ZoomInfoLogin/ZoomInfoLogin';

// import './mainLayout.css';

const MainLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  console.log('Location in Layout:', location);
  // State to track the value of 'asana-token' in sessionStorage
  const [asanaToken, setAsanaToken] = useState(localStorage.getItem('asana-token') || '');
  const [zoomInfoToken, setZoomInfoToken] = useState(localStorage.getItem('zoominfo-token') || '');

  const isBlurred = location?.pathname === '/asana' && !asanaToken ? true : false;
  const isZoomInfoBlurred = false; //location?.pathname === '/zoominfo' && !zoomInfoToken ? true : false;
  const handleAsanaUnlink = async (accessToken: string, refreshToken: string) => {
    try {
      const asanaCredentials = localStorage.getItem('asana-cred') || '';
      const parsedCreds = asanaCredentials ? JSON.parse(asanaCredentials) : {};
      const res = await AsanaService.asanaLogout(
        { refresh_token: refreshToken },
        { 'asana-token': accessToken },
      ); // Call the logout service
      localStorage.removeItem('asana-token');
      localStorage.removeItem('asana-expiry');
      localStorage.removeItem('asana-cred');
    } catch (err) {
      console.error('Error unlinking Asana:', err);
    }
  };
  async function exchangeCodeForToken(code: string) {
    try {
      const payload = {
        code,
        redirect_uri: process.env.REACT_APP_ASANA_REDIRECT,
      };
      const response = await AsanaService.asanaExchangeToken(payload);
      const validate = await AsanaService.asanaValidateToken({
        'asana-token': response?.access_token || '',
      });
      console.log(validate, 'validate token');
      // Remove any previous failure flag
      if (validate?.valid) {
        localStorage.removeItem('asana-fail');

        // Set the token in localStorage
        localStorage.setItem('asana-token', response?.access_token || '');
        localStorage.setItem('asana-cred', JSON.stringify(response || {}));
        // Calculate expiry time (3600 seconds from now)
        const expiryTime = new Date();
        expiryTime.setSeconds(expiryTime.getSeconds() + 3600); // Add 3600 seconds
        localStorage.setItem('asana-expiry', expiryTime.toISOString()); // Store expiry time in ISO format
        // Manually update the state to reflect the new token
        window.dispatchEvent(
          new CustomEvent('sessionStorageChange', {
            detail: { key: 'asana-token', value: response?.access_token || '' },
          }),
        );

        setAsanaToken(response?.access_token || '');

        return response;
      } else {
        handleAsanaUnlink(response?.access_token, response?.refresh_token);
      }
      window.dispatchEvent(
        new CustomEvent('asanaValidateToken', {
          detail: { key: 'asanaValidateToken', value: 'false' },
        }),
      );
    } catch (err) {
      console.log(err, 'validate err');
      localStorage.setItem('asana-fail', 'true');
      window.dispatchEvent(
        new CustomEvent('asanaValidateToken', {
          detail: { key: 'asanaValidateToken', value: 'false' },
        }),
      );
    }
  }

  useEffect(() => {
    const fetchToken = async () => {
      const token =
        !asanaToken &&
        location?.search?.split('code=')?.length > 1 &&
        (await exchangeCodeForToken(
          decodeURIComponent(location?.search?.split('code=')[1].split('&state=')[0]),
        ));

      // If a token is fetched, manually update the state
      if (token) {
        setAsanaToken(token?.access_token || '');
        navigate('/asana', { replace: true });
      }
    };
    const asanaConnecting = sessionStorage.getItem('asana-connecting');
    if (asanaConnecting === 'true') {
      sessionStorage.removeItem('asana-connecting');
      // If the user is connecting Asana, we want to fetch the token
      fetchToken();
    }
  }, [asanaToken, location?.search]);
  return (
    <Box
      display='flex'
      className='grid'
      sx={{ height: '100%', overflowY: 'hidden', width: '100%' }}
    >
      <Box flexBasis={{ xs: '30%', md: '210px' }}>
        <Sidebar />
      </Box>
      {/* <Box marginLeft={{ xs: 0, md: '10%' }} /> */}
      <Box
        flexBasis={{ xs: '100%', md: '100%' }}
        sx={{
          height: '100vh',
          width: { xs: '50%', sm: '70%', md: '85%' },
          margin: 'auto',
          overflow: 'hidden',
        }}
        paddingLeft={0}
      >
        <Header />
        <Box
          sx={{
            position: 'relative',
          }}
        >
          <Box
            sx={{
              filter: isBlurred || isZoomInfoBlurred ? 'blur(20px)' : 'none', // Apply blur only for "/asana"
              pointerEvents: isBlurred || isZoomInfoBlurred ? 'none' : 'auto', // Disable interactions if blurred
              transition: 'filter 0.3s ease', // Smooth transition for blur effect
              position: 'relative',
            }}
          >
            <Outlet />
          </Box>
          {/* Overlay for Login Message */}
          {(isBlurred || isZoomInfoBlurred) && (
            <>
              {location.pathname.includes('/asana') && <AsanaLogin />}
              {location.pathname.includes('/zoominfo') && <ZoomInfoLogin />}
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default MainLayout;
